/*! Ardor Printing banner stand 3D preview v1.0 (window.ArdorStand3D).
 * Needs global THREE (r147) and THREE.OrbitControls loaded first. No other files, no network loads.
 * Units are inches, y up, the stand's front faces +z. Each face texture is the WHOLE template page as printed;
 * only the spec's `visible` rect is mapped onto the graphic (hidden zones sit inside the base / under the rail). */
(function (root) {
  "use strict";

  var FOV = 28, EL_MAX = 1.45, EL_MIN = 0.02, DEFAULT_BG = "#f4f6f5", PI = Math.PI,
    FILL_HOME = 0.9, FILL_NEAR = 0.97, FILL_FAR = 0.45, SLAB = 1.25;
  // camera views: [azimuth (0 = front, +PI/2 = right side), elevation]
  var VIEWS = {
    home: [0.5, 0.14], front: [0, 0.06], back: [PI, 0.06], side: [1.05, 0.12],
    left: [-PI / 2, 0.06], right: [PI / 2, 0.06], top: [0, 1.4]
  };
  var PREFIX = { RS: "retractable", RD: "retractable", SD: "retractable-sd", TB: "tabletop", XS: "x-stand", TF: "tension", SR: "step-repeat" },
    DEF_SIZE = { retractable: [33, 81], "retractable-sd": [36, 92], tabletop: [11.5, 17.5], "x-stand": [24, 63], tension: [36, 90], "step-repeat": [120, 96] };

  function hasThree() {
    var T = root.THREE;
    return !!(T && T.WebGLRenderer && T.OrbitControls && T.BufferGeometry && T.MeshLambertMaterial && T.ShapeUtils &&
      T.CanvasTexture && T.CylinderGeometry && T.BoxGeometry && T.TubeGeometry && T.TorusGeometry && T.Box3 && T.QuadraticBezierCurve3);
  }

  function create(host, opts) {
    try { return !host || !hasThree() ? null : build(host, opts || {}); } catch (e) {
      try { // clean up a half-built viewer so the page can fall back to 2D
        var cs = host.querySelectorAll("canvas[data-ardor-stand3d='init']"), i, gl, ext;
        for (i = 0; i < cs.length; i++) {
          gl = cs[i].getContext("webgl2") || cs[i].getContext("webgl");
          ext = gl && gl.getExtension("WEBGL_lose_context");
          if (ext) ext.loseContext();
          if (cs[i].parentNode) cs[i].parentNode.removeChild(cs[i]);
        }
      } catch (e2) { }
      return null;
    }
  }

  /* ---------- input helpers (lenient: specs JSON or Shopify option text) ---------- */
  function num(v, lo, hi) {
    var n = Number(v);
    return v !== null && v !== "" && v !== true && v !== false && isFinite(n) && n >= lo && n <= hi ? n : null;
  }
  function str(v) { return v === null || v === undefined || typeof v === "object" ? "" : String(v).toLowerCase().replace(/^\s+|\s+$/g, ""); }
  function keyOf(v) { return typeof v === "string" ? v.replace(/^\s+|\s+$/g, "") : ""; }
  function bgColor(v) { return typeof v === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v.trim()) ? v.trim() : DEFAULT_BG; }
  function arr(v, n) {
    if (!v || typeof v !== "object" || typeof v.length !== "number" || v.length < n) return null;
    var o = [], i, x;
    for (i = 0; i < n; i++) { x = Number(v[i]); if (v[i] === null || v[i] === "" || !isFinite(x)) return null; o.push(x); }
    return o;
  }
  function famOf(v, key) {
    var s = str(v).replace(/[\s_]+/g, "-");
    if (s) {
      if (/table-?top|desk|mini/.test(s)) return "tabletop"; // ("retractable" also contains "table")
      if (/(^|-)sd($|-)|adjust/.test(s)) return "retractable-sd";
      if (/^x($|-|stand|banner)|x-?stand|x-?banner/.test(s)) return "x-stand";
      if (/tension|fabric|pillow/.test(s)) return "tension";
      if (/step|repeat|backdrop/.test(s)) return "step-repeat";
      if (/retract|roll|deluxe|standard/.test(s)) return "retractable";
    }
    return PREFIX[key.slice(0, 2).toUpperCase()] || null;
  }
  function clampRect(r, t) {
    if (!r) return null;
    var x0 = Math.max(0, r[0]), y0 = Math.max(0, r[1]), x1 = Math.min(t.w, r[0] + r[2]), y1 = Math.min(t.h, r[1] + r[3]);
    return x1 - x0 >= 1 && y1 - y0 >= 1 ? [x0, y0, x1 - x0, y1 - y0] : null;
  }
  // hidden strips that overlap the visible rect along a whole edge are trimmed off it
  function trimVis(v, hid) {
    if (!hid || typeof hid !== "object" || typeof hid.length !== "number") return v;
    v = v.slice();
    for (var i = 0; i < hid.length && i < 40; i++) {
      var h = hid[i], r = h && typeof h === "object" ? arr(h.rect, 4) || arr(h, 4) : null;
      if (!r || r[2] <= 0 || r[3] <= 0) continue;
      var x1 = v[0] + v[2], y1 = v[1] + v[3], rx = r[0] + r[2], ry = r[1] + r[3];
      if (r[0] <= v[0] + 0.05 && rx >= x1 - 0.05) {
        if (r[1] <= v[1] + 0.05 && ry > v[1] && ry < y1 - 1) { v[3] = y1 - ry; v[1] = ry; }
        else if (ry >= y1 - 0.05 && r[1] < y1 && r[1] > v[1] + 1) v[3] = r[1] - v[1];
      } else if (r[1] <= v[1] + 0.05 && ry >= y1 - 0.05) {
        if (r[0] <= v[0] + 0.05 && rx > v[0] && rx < x1 - 1) { v[2] = x1 - rx; v[0] = rx; }
        else if (rx >= x1 - 0.05 && r[0] < x1 && r[0] > v[0] + 1) v[2] = r[0] - v[0];
      }
    }
    return v;
  }
  // a plausible template when the specs leave something out (retractables: 5 in rolls into the base)
  function defaults(fam, key) {
    var m = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i.exec(key), D = DEF_SIZE[fam], W = m ? +m[1] : D[0], H = m ? +m[2] : D[1],
      hid = fam === "tabletop" ? 2 : /^retract/.test(fam) ? 5 : 0;
    if (fam === "step-repeat" && W <= 20 && H <= 20) { W *= 12; H *= 12; } // "SR-10x8" is in feet
    W = Math.max(4, Math.min(400, W)); H = Math.max(4, Math.min(400, H));
    return { tpl: { w: W, h: H + hid }, vis: [0, 0, W, H] };
  }
  function normalize(o) {
    var key = keyOf(o.key), hw = o.hardware && typeof o.hardware === "object" ? o.hardware : {},
      fam = famOf(o.family, key) || famOf(o.name, key) || "retractable", K = key.slice(0, 2).toUpperCase(),
      words = [o.family, o.name, hw.base, hw.type, hw.style, hw.frame, hw.graphic].map(str).join(" "),
      d = defaults(fam, key), tw = o.tpl ? num(o.tpl.w, 2, 800) : null, th = o.tpl ? num(o.tpl.h, 2, 800) : null,
      tpl = tw && th ? { w: tw, h: th } : d.tpl, vis = clampRect(arr(o.visible, 4), tpl), f = num(o.faces, 1, 2), i, p;
    vis = trimVis(vis || (tw && th ? [0, 0, tw, th] : d.vis), o.hidden);
    if (/^retract/.test(fam) && K === "SD") fam = "retractable-sd";
    if (f === null) f = /-2S(?![A-Z0-9])/i.test(key) || /double|2[- ]?side|two/.test(str(o.sides)) || (fam === "tension" && !/single|1[- ]?side/.test(str(o.sides))) ? 2 : 1;
    var bt = o.backTpl && typeof o.backTpl === "object" ? o.backTpl : null, btw = bt ? num(bt.w, 2, 800) : null,
      bth = bt ? num(bt.h, 2, 800) : null, same = !btw || !bth || bt.sameAsFront === true || (Math.abs(btw - tpl.w) < 0.02 && Math.abs(bth - tpl.h) < 0.02),
      btpl = same ? tpl : { w: btw, h: bth },
      bvis = clampRect(arr(o.backVisible || (bt && bt.visible), 4), btpl) || (same ? vis : trimVis([0, 0, btpl.w, btpl.h], o.backHidden || (bt && bt.hidden)));
    // step and repeat: pole pocket bands (top and bottom, 3 in by default)
    var pk = [], pl = o.pockets && typeof o.pockets === "object" && typeof o.pockets.length === "number" ? o.pockets : [];
    for (i = 0; i < pl.length && i < 4; i++) { p = pl[i] && typeof pl[i] === "object" ? arr(pl[i].rect, 4) || arr(pl[i], 4) : null; if (p && p[3] > 0.2) pk.push([p[1], p[3]]); }
    var gr = [], g = o.grommets;
    if (g && typeof g === "object" && typeof g.length === "number") for (i = 0; i < g.length && i < 24; i++) {
      p = g[i] && typeof g[i] === "object" ? arr(g[i], 2) || arr([g[i].x, g[i].y], 2) : null;
      if (p) gr.push(p);
    }
    if (fam === "x-stand" && gr.length < 4) {
      var gi = Math.min(1, vis[2] / 6, vis[3] / 6);
      gr = [[vis[0] + gi, vis[1] + gi], [vis[0] + vis[2] - gi, vis[1] + gi], [vis[0] + gi, vis[1] + vis[3] - gi], [vis[0] + vis[2] - gi, vis[1] + vis[3] - gi]];
    }
    var sd = fam === "retractable-sd", prem = sd || K === "RD" || /deluxe|premium/.test(words), ft = num(hw.feet, 0, 8),
      W = vis[2], H = vis[3], md = o.model && typeof o.model === "object" ? o.model : {}, m, kk;
    // modelling defaults (same numbers as BS-SPECS' `model` block; a passed `model` overrides them)
    m = fam === "x-stand" ? { footSpread: 0.9 * W, hubHeight: 0.42 * H } :
      fam === "tension" ? { tubeDia: 1.25, plateW: W + 8, plateD: 16, plateH: 0.4, topCornerRadius: W >= 48 ? 5 : 4.5 } :
      fam === "step-repeat" ? { footLen: 22, footW: 4, uprightExtraTop: 1.5, graphicBottomAboveFloor: 4 } :
      fam === "tabletop" ? { baseW: W + 1.25, baseD: 2.6, baseH: 2.2, feetLen: 5.5, chromeEnds: true, poleCount: 1 } :
      sd ? { baseW: W + 2, baseD: 10.5, baseH: 3.5, feetLen: 0, chromeEnds: true, poleCount: W >= 60 ? 2 : 1 } :
      prem ? { baseW: W + 2, baseD: 8.5, baseH: 4.5, feetLen: 0, chromeEnds: true, poleCount: 1 } :
      { baseW: W + 1.5, baseD: 3.2, baseH: 4, feetLen: 11, chromeEnds: false, poleCount: 1 };
    for (kk in m) if (m.hasOwnProperty(kk)) {
      if (typeof m[kk] === "boolean") { if (typeof md[kk] === "boolean") m[kk] = md[kk]; }
      else { i = num(md[kk], 0, 400); if (i !== null) m[kk] = i; }
    }
    if (ft === null && md.feetLen !== undefined) ft = m.feetLen > 0 ? 2 : 0;
    return {
      key: key, fam: fam, sd: sd, prem: prem, faces: Math.round(f), tpl: tpl, vis: vis, btpl: btpl, bvis: bvis,
      grom: fam === "x-stand" ? gr : [], pk: pk, m: m,
      dark: /black/.test(words) || /^RS-[\d.]+x[\d.]+B(?![A-Z])|-(BLK|BLACK)(?![A-Z])/i.test(key), // black hardware
      feet: ft !== null ? ft > 0 : !prem, // swivel feet under the cassette (deluxe and SD bases stand on their own)
      tele: sd || hw.poleAdjustable === true || (prem && hw.adjustable === true), // telescopic pole
      style: /pillow|tension|zip/.test(words) ? "pillow" : "pocket", // step and repeat: pole pocket backdrop by default
      order: str(o.order).toUpperCase()
    };
  }
  function geoKey(C) { return JSON.stringify([C.key, C.fam, C.prem, C.faces, C.vis, C.grom, C.pk, C.dark, C.feet, C.tele, C.m, C.fam === "step-repeat" ? C.style : ""]); }

  function rng(seed) { return function () { seed = seed * 16807 % 2147483647; return seed / 2147483647; }; }
  // outlines (CCW in their own plane)
  function loaf(zc, D, y0, Hb, p, n) { // flat bottom, superellipse top: the cassette profile
    var pts = [[zc - D / 2, y0], [zc + D / 2, y0]], i, t, c, s;
    for (i = 1; i < n; i++) {
      t = PI * i / n; c = Math.cos(t); s = Math.sin(t);
      pts.push([zc + (c < 0 ? -1 : 1) * Math.pow(Math.abs(c), 2 / p) * D / 2, y0 + Math.pow(s, 2 / p) * Hb]);
    }
    return pts;
  }
  function rrect(cx, cy, w, h, r, n) {
    r = Math.min(r, w / 2, h / 2);
    var pts = [], c = [[w / 2 - r, -h / 2 + r, -PI / 2], [w / 2 - r, h / 2 - r, 0], [-w / 2 + r, h / 2 - r, PI / 2], [-w / 2 + r, -h / 2 + r, PI]], i, k, a, x, y, L;
    for (k = 0; k < 4; k++) for (i = 0; i <= n; i++) {
      a = c[k][2] + PI / 2 * i / n; x = cx + c[k][0] + r * Math.cos(a); y = cy + c[k][1] + r * Math.sin(a); L = pts[pts.length - 1];
      if (!L || Math.abs(L[0] - x) + Math.abs(L[1] - y) > 1e-6) pts.push([x, y]);
    }
    L = pts[pts.length - 1];
    if (Math.abs(L[0] - pts[0][0]) + Math.abs(L[1] - pts[0][1]) < 1e-6) pts.pop();
    return pts;
  }

  /* ---------- viewer ---------- */
  function build(host, opts) {
    var THREE = root.THREE, doc = host.ownerDocument || document, win = doc.defaultView || root,
      bg = bgColor(opts.background), canvas = doc.createElement("canvas");
    canvas.setAttribute("aria-label", "3D preview of your banner stand. Drag to turn it.");
    canvas.setAttribute("data-ardor-stand3d", "init");
    canvas.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;inset:0;width:100%;height:100%;display:block;touch-action:none;outline:none;cursor:grab;";
    var attrs = { alpha: false, antialias: true, depth: true, stencil: false, premultipliedAlpha: true, preserveDrawingBuffer: false },
      gl = null;
    try { gl = canvas.getContext("webgl2", attrs); } catch (e1) { gl = null; }
    if (!gl) try { gl = canvas.getContext("webgl", attrs) || canvas.getContext("experimental-webgl", attrs); } catch (e2) { gl = null; }
    if (!gl) return null;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, context: gl, antialias: true, alpha: false, stencil: false, preserveDrawingBuffer: false });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.NoToneMapping;
    renderer.setClearColor(new THREE.Color(bg), 1);
    try { if (win.getComputedStyle && win.getComputedStyle(host).position === "static") host.style.position = "relative"; } catch (e3) { }
    host.appendChild(canvas);

    var maxAniso = 1;
    try { maxAniso = renderer.capabilities.getMaxAnisotropy() || 1; } catch (e4) { maxAniso = 1; }
    var canMip = !!renderer.capabilities.isWebGL2, scene = new THREE.Scene(),
      camera = new THREE.PerspectiveCamera(FOV, 1, 1, 4000), disposed = false;
    scene.add(camera);

    function lin(hex) { var c = new THREE.Color(hex); c.convertSRGBToLinear(); return c; }
    // lights: soft sky/ground fill, a light that follows the camera (so every side reads), a fixed key and back fill
    var hemi = new THREE.HemisphereLight(lin("#ffffff"), lin("#c9c4ba"), 0.46);
    hemi.position.set(0, 1, 0);
    scene.add(hemi);
    var head = new THREE.DirectionalLight(0xffffff, 0.34);
    head.position.set(-0.3, 0.5, 1);
    camera.add(head); camera.add(head.target);
    var key = new THREE.DirectionalLight(0xffffff, 0.36), fill = new THREE.DirectionalLight(0xffffff, 0.26);
    key.position.set(-0.45, 0.55, 0.7); fill.position.set(0.4, 0.5, -0.75);
    scene.add(key); scene.add(fill);

    /* materials (kept for the life of the viewer) */
    // print material: geometry uv 0..1 spans the face's visible area; its texture is that area cropped out of the page
    function artMat(tag) {
      var m = new THREE.MeshLambertMaterial({ color: 0xffffff });
      m.onBeforeCompile = function (sh) { // transparent print pixels read as white material
        sh.fragmentShader = sh.fragmentShader.replace("#include <map_fragment>", ["#ifdef USE_MAP",
          "  vec4 tc = texture2D( map, vUv );", "  tc.rgb = mix( vec3( 1.0 ), tc.rgb, tc.a );",
          "  diffuseColor.rgb *= tc.rgb;", "#endif"].join("\n"));
      };
      m.customProgramCacheKey = function () { return tag; };
      return m;
    }
    var frontMat = artMat("ardorStandFront"), backMat = artMat("ardorStandBack");
    function lam(hex) { return new THREE.MeshLambertMaterial({ color: lin(hex) }); }
    function metal(hex, shin, spec) { return new THREE.MeshPhongMaterial({ color: lin(hex), specular: lin(spec || "#4a4f55"), shininess: shin || 50 }); }
    var M = {
      backing: lam("#e1e1dd"), fabric: lam("#efefeb"), alu: metal("#b9bec4", 55, "#70767d"), chrome: metal("#d2d6da", 90, "#a3a9b0"),
      cap: metal("#26282c", 30, "#3c4046"), grey: lam("#8e9297"), slot: lam("#141517"), frame: metal("#1d1e21", 40, "#474b51"),
      ring: metal("#c8cdd2", 80, "#8a9097"), steel: metal("#6b7076", 35, "#565b61"), slabEdge: lam("#b9b1a4"), rubber: lam("#2b2c2f")
    };
    var groundMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, depthWrite: false, toneMapped: false });

    function plainTexture(c) {
      var t = new THREE.CanvasTexture(c);
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = maxAniso;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.magFilter = THREE.LinearFilter;
      t.minFilter = canMip ? THREE.LinearMipmapLinearFilter : THREE.LinearFilter;
      t.generateMipmaps = canMip;
      return t;
    }
    var groundCv = doc.createElement("canvas");
    groundCv.width = groundCv.height = 1024;
    var groundTex = plainTexture(groundCv);
    groundMat.map = groundTex;
    var slabCv = doc.createElement("canvas");
    slabCv.width = 512; slabCv.height = 256;
    var slabTex = plainTexture(slabCv), slabMat = new THREE.MeshLambertMaterial({ color: 0xffffff, map: slabTex });

    var input = {}, state = normalize({ key: "RS-33x81" }), builtKey = "", standRoot = null, geos = [], ground = null,
      ptsAll = [], ptsNear = [], cAll = new THREE.Vector3(), target = new THREE.Vector3(0, 40, 0), fitHome = 300,
      size = { w: 0, h: 0 }, faces = { front: { src: null, tex: null, ck: "", cv: doc.createElement("canvas") }, back: { src: null, tex: null, ck: "", cv: doc.createElement("canvas") } };

    var placeCv = doc.createElement("canvas"), placeTex = null, placeKey = "";
    function placeholder() { // plain white print with a hint, until the designer sends a canvas
      var w = state.vis[2], h = state.vis[3], k = Math.min(1024 / Math.max(w, h), 40), cw = Math.max(8, Math.round(w * k)),
        ch = Math.max(8, Math.round(h * k)), pk = cw + "x" + ch;
      if (placeTex && pk === placeKey) return placeTex;
      placeKey = pk;
      if (placeTex) placeTex.dispose();
      placeCv.width = cw; placeCv.height = ch;
      var g = placeCv.getContext("2d"), fs = Math.round(Math.min(cw * 0.068, ch * 0.2));
      g.fillStyle = "#ffffff"; g.fillRect(0, 0, cw, ch);
      g.fillStyle = "#a6abb2"; g.textAlign = "center"; g.textBaseline = "middle";
      g.font = "600 " + fs + "px Helvetica, Arial, sans-serif";
      g.fillText("Your artwork goes here", cw / 2, ch * 0.42);
      placeTex = plainTexture(placeCv);
      return placeTex;
    }
    // Each face's VISIBLE rect is copied out of the template page into its own canvas, so hidden zones and bleed never
    // reach the GPU (no colour from them can bleed into the edges at any mip level).
    function crop(name, force) {
      var f = faces[name], src = f.src, v = name === "front" ? state.vis : state.bvis, t = name === "front" ? state.tpl : state.btpl;
      if (!src || !(src.width > 0) || !(src.height > 0)) { if (f.tex) f.tex.dispose(); f.tex = null; f.ck = ""; return; }
      var sx = src.width / t.w, sy = src.height / t.h, cw = Math.max(2, Math.min(4096, Math.round(v[2] * sx))),
        ch = Math.max(2, Math.min(4096, Math.round(v[3] * sy))), ck = [v, t.w, t.h, src.width, src.height].join(",");
      if (!force && f.tex && ck === f.ck) return;
      f.ck = ck;
      if (f.cv.width !== cw || f.cv.height !== ch || !f.tex) {
        f.cv.width = cw; f.cv.height = ch;
        if (f.tex) f.tex.dispose();
        f.tex = plainTexture(f.cv);
      } else f.tex.needsUpdate = true;
      // 1.5 source pixels in from each side, so the (anti-aliased) boundary pixel never gets in
      var g = f.cv.getContext("2d"), w = v[2] * sx, h = v[3] * sy, ix = w > 24 ? 1.5 : 0, iy = h > 24 ? 1.5 : 0;
      g.clearRect(0, 0, cw, ch);
      try { g.drawImage(src, v[0] * sx + ix, v[1] * sy + iy, w - 2 * ix, h - 2 * iy, 0, 0, cw, ch); } catch (e) { }
    }
    function setMap(m, t) { if (m.map !== t) { if (!m.map !== !t) m.needsUpdate = true; m.map = t; } }
    function bindTextures() {
      var f = faces.front.tex || placeholder();
      setMap(frontMat, f);
      // 2 sided: the back print, or the front print again ("same as front"), reading correctly from behind
      setMap(backMat, faces.back.tex || f);
    }

    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.12;
    controls.rotateSpeed = 0.8;
    controls.zoomSpeed = 0.9;
    controls.minPolarAngle = PI / 2 - EL_MAX;
    controls.maxPolarAngle = PI / 2 - EL_MIN;

    /* ---------- geometry helpers ---------- */
    function addTo(G, geo, mat, x, y, z) {
      var m = new THREE.Mesh(geo, mat);
      m.position.set(x || 0, y || 0, z || 0);
      G.add(m); geos.push(geo);
      return m;
    }
    function boxAt(G, mat, w, h, d, x, y, z) { return addTo(G, new THREE.BoxGeometry(w, h, d), mat, x, y, z); }
    function cylAt(G, mat, r0, r1, y0, y1, x, z, seg) {
      return addTo(G, new THREE.CylinderGeometry(r1, r0, y1 - y0, seg || 18), mat, x, (y0 + y1) / 2, z);
    }
    function rod(G, mat, r, a, b, seg) { // a thin cylinder from point a to point b
      var va = new THREE.Vector3(a[0], a[1], a[2]), vb = new THREE.Vector3(b[0], b[1], b[2]),
        m = addTo(G, new THREE.CylinderGeometry(r, r, va.distanceTo(vb), seg || 12), mat);
      m.position.copy(va).add(vb).multiplyScalar(0.5);
      m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), vb.sub(va).normalize());
      return m;
    }
    function disposeGeos() { for (var i = 0; i < geos.length; i++) try { geos[i].dispose(); } catch (e) { } geos.length = 0; }
    function geoOf(P, N, T, I) {
      var g = new THREE.BufferGeometry();
      g.setAttribute("position", new THREE.Float32BufferAttribute(P, 3));
      g.setAttribute("normal", new THREE.Float32BufferAttribute(N, 3));
      if (T) g.setAttribute("uv", new THREE.Float32BufferAttribute(T, 2));
      g.setIndex(I);
      return g;
    }
    // grid surface: f(i, j, out) fills out = [x, y, z, nx, ny, nz, u, v]; triangles face along the normals
    function surf(nu, nv, f) {
      var P = [], N = [], T = [], I = [], o = [0, 0, 0, 0, 0, 1, 0, 0], i, j;
      for (j = 0; j <= nv; j++) for (i = 0; i <= nu; i++) { f(i, j, o); P.push(o[0], o[1], o[2]); N.push(o[3], o[4], o[5]); T.push(o[6], o[7]); }
      function tri(a, b, c) {
        var ux = P[3 * b] - P[3 * a], uy = P[3 * b + 1] - P[3 * a + 1], uz = P[3 * b + 2] - P[3 * a + 2],
          vx = P[3 * c] - P[3 * a], vy = P[3 * c + 1] - P[3 * a + 1], vz = P[3 * c + 2] - P[3 * a + 2],
          cx = uy * vz - uz * vy, cy = uz * vx - ux * vz, cz = ux * vy - uy * vx;
        if (cx * cx + cy * cy + cz * cz < 1e-14) return;
        if (cx * (N[3 * a] + N[3 * b] + N[3 * c]) + cy * (N[3 * a + 1] + N[3 * b + 1] + N[3 * c + 1]) + cz * (N[3 * a + 2] + N[3 * b + 2] + N[3 * c + 2]) < 0) I.push(a, c, b);
        else I.push(a, b, c);
      }
      for (j = 0; j < nv; j++) for (i = 0; i < nu; i++) {
        var a = j * (nu + 1) + i, b = a + 1, c = a + nu + 2, d = a + nu + 1;
        tri(a, b, c); tri(a, c, d);
      }
      return geoOf(P, N, T, I);
    }
    // a 2D outline (CCW, [a, b]) swept along c from c0 to c1 with flat end caps; ax maps (a, b, c) to world axes.
    // Corners sharper than about 37 degrees stay crisp.
    function prism(pts, c0, c1, ax) {
      var n = pts.length, P = [], N = [], I = [], en = [], odd = (ax[0] + 1) % 3 !== ax[1], i, j, k;
      function put(a, b, c, na, nb, nc) {
        var v = [0, 0, 0], w = [0, 0, 0];
        v[ax[0]] = a; v[ax[1]] = b; v[ax[2]] = c; w[ax[0]] = na; w[ax[1]] = nb; w[ax[2]] = nc;
        P.push(v[0], v[1], v[2]); N.push(w[0], w[1], w[2]);
        return P.length / 3 - 1;
      }
      function tri(a, b, c) { if (odd) I.push(a, c, b); else I.push(a, b, c); }
      function vn(e0, e1) {
        if (e0[0] * e1[0] + e0[1] * e1[1] < 0.8) return null;
        var x = e0[0] + e1[0], y = e0[1] + e1[1], l = Math.sqrt(x * x + y * y) || 1;
        return [x / l, y / l];
      }
      for (i = 0; i < n; i++) {
        var p = pts[i], q = pts[(i + 1) % n], dx = q[0] - p[0], dy = q[1] - p[1], l = Math.sqrt(dx * dx + dy * dy) || 1;
        en.push([dy / l, -dx / l]);
      }
      for (i = 0; i < n; i++) {
        j = (i + 1) % n;
        var e = en[i], na = vn(en[(i + n - 1) % n], e) || e, nb = vn(e, en[j]) || e,
          A = put(pts[i][0], pts[i][1], c0, na[0], na[1], 0), B = put(pts[j][0], pts[j][1], c0, nb[0], nb[1], 0),
          Cc = put(pts[j][0], pts[j][1], c1, nb[0], nb[1], 0), D = put(pts[i][0], pts[i][1], c1, na[0], na[1], 0);
        tri(A, B, Cc); tri(A, Cc, D);
      }
      var tr = THREE.ShapeUtils.triangulateShape(pts.map(function (p) { return new THREE.Vector2(p[0], p[1]); }), []), b0 = P.length / 3;
      for (i = 0; i < n; i++) put(pts[i][0], pts[i][1], c1, 0, 0, 1);
      for (i = 0; i < n; i++) put(pts[i][0], pts[i][1], c0, 0, 0, -1);
      for (k = 0; k < tr.length; k++) {
        var a = tr[k][0], b = tr[k][1], c = tr[k][2], t;
        if ((pts[b][0] - pts[a][0]) * (pts[c][1] - pts[a][1]) - (pts[b][1] - pts[a][1]) * (pts[c][0] - pts[a][0]) < 0) { t = b; b = c; c = t; }
        tri(b0 + a, b0 + b, b0 + c);
        tri(b0 + n + a, b0 + n + c, b0 + n + b);
      }
      return geoOf(P, N, null, I);
    }
    // the printed sheet: W x H from y0 up, at z0 (edges curl back by `curl`); dir +1 faces front, -1 faces back
    // (u runs left to right as seen from that side, so a print reads correctly from where it is seen)
    function sheet(W, H, z0, y0, curl, dir) {
      return surf(12, 1, function (i, j, o) {
        var t = i / 12, e = 2 * t - 1;
        o[0] = (t - 0.5) * W; o[1] = y0 + H * j; o[2] = z0 - curl * e * e * e * e;
        o[3] = 0; o[4] = 0; o[5] = dir; o[6] = dir > 0 ? t : 1 - t; o[7] = j;
      });
    }
    function flatPoly(poly, z, dir, uvf) { // a flat face (x, y outline) at z, facing dir
      var P = [], N = [], T = [], I = [], i, k, uv,
        tr = THREE.ShapeUtils.triangulateShape(poly.map(function (p) { return new THREE.Vector2(p[0], p[1]); }), []);
      for (i = 0; i < poly.length; i++) {
        uv = uvf(poly[i][0], poly[i][1]);
        P.push(poly[i][0], poly[i][1], z); N.push(0, 0, dir); T.push(dir > 0 ? uv[0] : 1 - uv[0], uv[1]);
      }
      for (k = 0; k < tr.length; k++) {
        var a = tr[k][0], b = tr[k][1], c = tr[k][2],
          cr = (poly[b][0] - poly[a][0]) * (poly[c][1] - poly[a][1]) - (poly[b][1] - poly[a][1]) * (poly[c][0] - poly[a][0]);
        if (cr * dir < 0) I.push(a, c, b); else I.push(a, b, c);
      }
      return geoOf(P, N, T, I);
    }
    function foot(G, mat, x, z, w, l, y0, y1) { addTo(G, prism(rrect(x, z, w, l, w / 2, 6), y0, y1, [0, 2, 1]), mat); }

    /* ---------- the stands ---------- */
    // Retractables (standard, deluxe 1 or 2 sided, SD) and the tabletop mini: an aluminium cassette base with end caps
    // (standard: on two swivel feet; deluxe and SD: a wider base that stands on its own), the print pulled up out of a
    // slot, a top rail clamping its top edge and a pole behind it (telescopic on adjustable stands).
    function buildRetract(G, sh) {
      var C = state, m = C.m, W = C.vis[2], H = C.vis[3], tab = C.fam === "tabletop", prem = C.prem, two = C.faces === 2, feet = C.feet,
        k = tab ? 0.5 : 1, lift = tab ? SLAB : 0, ft = feet ? (tab ? 0.18 : 0.35) : 0.12, y0 = lift + ft,
        capT = tab ? 0.3 : 0.55, L = Math.max(W + 0.2, m.baseW - 2 * capT), D = Math.max(two ? 6 : 2, m.baseD),
        Hb = Math.max(1, m.baseH - ft), pw = prem ? 2.1 : 2.6, fm = D >= 6 ? 2.1 : D * 0.42,
        zc = two ? 0 : fm - D / 2, gz = two ? Math.min(1.3, D / 2 - 1.4) : 0, pz = two ? 0 : tab ? -0.7 : -Math.min(2.4, 0.3 * D + 0.3),
        pr = tab ? 0.17 : 0.4, rh = tab ? 0.68 : 1.15, rd = tab ? 0.55 : 0.9, np = two || tab ? 1 : Math.max(1, Math.min(2, Math.round(m.poleCount))),
        dk = C.dark, body = dk ? M.frame : M.alu, capMat = m.chromeEnds ? M.chrome : dk ? M.frame : M.cap,
        curl = tab ? 0.06 : 0.18, i, j, s, rz, px;
      function topAt(z) { var t = Math.min(1, Math.abs(z - zc) / (D / 2)); return y0 + Hb * Math.pow(1 - Math.pow(t, pw), 1 / pw); }
      var yb = topAt(gz) - 0.04, yt = yb + H, sides = two ? [1, -1] : [1];
      addTo(G, prism(loaf(zc, D, y0, Hb, pw, 40), -L / 2, L / 2, [2, 1, 0]), body);
      for (i = -1; i <= 1; i += 2)
        addTo(G, prism(loaf(zc, D + 0.16, y0 - 0.02, Hb + 0.1, pw, 40), i < 0 ? -L / 2 - capT : L / 2, i < 0 ? -L / 2 : L / 2 + capT, [2, 1, 0]), capMat);
      for (i = 0; i < sides.length; i++) {
        s = sides[i]; rz = s * gz - s * 0.08 * k;
        boxAt(G, M.slot, W + 0.2, 0.08, tab ? 0.22 : 0.4, 0, topAt(s * gz) - 0.01, s * gz);
        // the print and its plain reverse; the rail clamps the top edge
        addTo(G, sheet(W, H, s * gz, yb, s * curl, s), s > 0 ? frontMat : backMat);
        addTo(G, sheet(W, H, s * gz, yb, s * curl, -s), M.backing);
        addTo(G, prism(rrect(rz, yt + rh / 2 - 0.03, rd, rh, 0.28 * k, 4), -W / 2 - 0.12, W / 2 + 0.12, [2, 1, 0]), dk ? M.frame : M.alu);
        boxAt(G, M.cap, 0.22, rh + 0.06, rd + 0.04, -W / 2 - 0.23, yt + rh / 2 - 0.03, rz);
        boxAt(G, M.cap, 0.22, rh + 0.06, rd + 0.04, W / 2 + 0.23, yt + rh / 2 - 0.03, rz);
      }
      // the pole(s) behind the print (between the two prints when 2 sided), clipped into the rail
      var p0 = topAt(pz) - 0.3, p1 = yt + rh * 0.55, z1 = gz - rd / 2 - 0.08 * k + 0.05, z0 = pz - pr * 0.5, ym = yb + 0.42 * H;
      for (j = 0; j < np; j++) {
        px = np === 2 ? (j ? 1 : -1) * W / 4 : 0;
        if (two) boxAt(G, M.cap, 1.6, 0.8, 2 * gz, px, yt + rh * 0.55, 0);
        else boxAt(G, M.cap, 1.2 * k + 0.2, 0.85 * k, z1 - z0, px, yt + rh * 0.5, (z0 + z1) / 2);
        cylAt(G, M.cap, pr + 0.28, pr + 0.2, topAt(pz) - 0.4, topAt(pz) + 0.75 * k, px, pz);
        if (C.tele && !tab) { // adjustable height: a thicker lower tube, a twist-lock collar and a slimmer upper tube
          cylAt(G, body, 0.55, 0.55, p0, ym, px, pz); cylAt(G, body, 0.4, 0.4, ym, p1, px, pz);
          cylAt(G, M.cap, 0.74, 0.7, ym - 0.6, ym + 0.8, px, pz);
          rod(G, M.cap, 0.2, [px, ym + 0.1, pz - 0.6], [px, ym + 0.1, pz - 1.5]);
          cylAt(G, M.cap, 0.42, 0.42, ym - 0.1, ym + 0.3, px, pz - 1.5).rotation.x = PI / 2;
        } else {
          cylAt(G, body, pr, pr, p0, p1, px, pz);
          if (!tab) for (i = 1; i < 3; i++) cylAt(G, M.cap, pr + 0.04, pr + 0.04, p0 + (p1 - p0) * i / 3 - 0.25, p0 + (p1 - p0) * i / 3 + 0.25, px, pz);
        }
      }
      if (feet) { // swivel feet under the base
        var fx = L / 2 - (tab ? 1.2 : 3.2), fw = tab ? 0.8 : prem ? 2 : 1.5, fl = Math.max(D + 2, m.feetLen || (tab ? 5.5 : 11)), fz = zc;
        for (i = -1; i <= 1; i += 2) {
          foot(G, m.chromeEnds ? M.chrome : dk ? M.frame : M.alu, i * fx, fz, fw, fl, lift, y0);
          sh.push(["r", i * fx - fw / 2, fz - fl / 2, i * fx + fw / 2, fz + fl / 2, 0.42, 0.8]);
        }
      } else for (i = 0; i < 4; i++) boxAt(G, M.rubber, 1.6, ft, D * 0.6, (i & 1 ? 1 : -1) * (L / 2 - 2), lift + ft / 2, zc);
      sh.push(["r", -L / 2 - capT, zc - D / 2, L / 2 + capT, zc + D / 2, feet ? 0.32 : 0.42, feet ? 1.6 + ft * 3 : 1]);
      sh.push(["r", -L / 2 - capT - 3, zc - D / 2 - 3, L / 2 + capT + 3, zc + D / 2 + 3, 0.16, 9 * k]);
    }
    // the tabletop mini stand stands on a short piece of table top
    function buildSlab(G, sh, fl) {
      var W = state.vis[2], SW = Math.max(24, W + 14.5), SD = SW / 2, zs = -1.5, g = slabCv.getContext("2d"), N = 512, s = N / SW, rnd = rng(7), i;
      boxAt(G, M.slabEdge, SW, SLAB - 0.02, SD, 0, (SLAB - 0.02) / 2, zs);
      var top = addTo(G, new THREE.PlaneGeometry(SW, SD), slabMat, 0, SLAB, zs);
      top.rotation.x = -PI / 2;
      g.setTransform(1, 0, 0, 1, 0, 0); g.globalCompositeOperation = "source-over"; g.shadowColor = "rgba(0,0,0,0)"; g.shadowBlur = 0;
      g.fillStyle = "#d8d1c5"; g.fillRect(0, 0, N, N / 2);
      for (i = 0; i < 2500; i++) { g.fillStyle = rnd() > 0.5 ? "rgba(255,255,255,0.3)" : "rgba(90,80,70,0.08)"; g.fillRect(rnd() * N, rnd() * N / 2, 1 + rnd() * 3, 1); }
      paintShadows(g, -SW / 2, zs - SD / 2, s, sh);
      slabTex.needsUpdate = true;
      fl.push(["r", -SW / 2, zs - SD / 2, SW / 2, zs + SD / 2, 0.36, 1.4], ["r", -SW / 2 - 3, zs - SD / 2 - 3, SW / 2 + 3, zs + SD / 2 + 3, 0.16, 8]);
    }
    // X-stand: the print hangs taut from 4 corner grommets on the arms of a black X frame (centre pole, tripod foot)
    function buildX(G, sh) {
      var C = state, W = C.vis[2], H = C.vis[3], yb = Math.max(4, Math.min(8, H * 0.09)), hd = Math.max(4, Math.min(9, H * 0.1)),
        vx = C.vis[0] + W / 2, vt = C.vis[1] + H, i, j, p, best, corner = [];
      function wx(q) { return [q[0] - vx, yb + vt - q[1]]; }
      addTo(G, sheet(W, H, 0, yb, 0, 1), frontMat);
      addTo(G, sheet(W, H, 0, yb, 0, -1), M.backing);
      var ring = new THREE.TorusGeometry(0.3, 0.075, 8, 20);
      geos.push(ring);
      for (i = 0; i < C.grom.length * 2; i++) {
        p = wx(C.grom[i >> 1]);
        var rm = new THREE.Mesh(ring, M.ring);
        rm.position.set(p[0], p[1], i & 1 ? -0.03 : 0.03);
        G.add(rm);
      }
      var cs = [[-W / 2, yb + H], [W / 2, yb + H], [-W / 2, yb], [W / 2, yb]], hy = 0;
      for (j = 0; j < 4; j++) { // the grommet nearest each corner
        best = null;
        for (i = 0; i < C.grom.length; i++) {
          p = wx(C.grom[i]);
          var dd = (p[0] - cs[j][0]) * (p[0] - cs[j][0]) + (p[1] - cs[j][1]) * (p[1] - cs[j][1]);
          if (!best || dd < best[2]) best = [p[0], p[1], dd];
        }
        corner.push(best || [cs[j][0] * 0.92, cs[j][1], 0]);
      }
      hy = Math.max(yb + 0.2 * H, Math.min(yb + 0.8 * H, C.m.hubHeight)); // where the arms cross
      var hub = new THREE.Vector3(0, hy, -hd), lr = Math.max(6, C.m.footSpread / 1.73);
      for (j = 0; j < 4; j++) {
        var c = corner[j], end = new THREE.Vector3(c[0], c[1], -0.45), mid = hub.clone().add(end).multiplyScalar(0.5);
        mid.z -= 0.08 * hub.distanceTo(end);
        addTo(G, new THREE.TubeGeometry(new THREE.QuadraticBezierCurve3(hub, mid, end), 14, 0.24, 7, false), M.frame);
        rod(G, M.frame, 0.11, [c[0], c[1], -0.5], [c[0], c[1], 0.2], 8);
        addTo(G, new THREE.SphereGeometry(0.17, 10, 6), M.frame, c[0], c[1], 0.22);
      }
      rod(G, M.frame, 0.7, [0, hy, -hd - 0.6], [0, hy, -hd + 0.5], 16);
      cylAt(G, M.frame, 0.36, 0.36, 3.2, hy - 0.5, 0, -hd);
      cylAt(G, M.frame, 0.55, 0.5, 2.6, 4.2, 0, -hd);
      var legs = [[0, -hd - lr], [-0.866 * lr, -hd + lr / 2], [0.866 * lr, -hd + lr / 2]];
      for (i = 0; i < 3; i++) {
        rod(G, M.frame, 0.3, [0, 3.4, -hd], [legs[i][0], 0.45, legs[i][1]], 10);
        cylAt(G, M.rubber, 0.55, 0.55, 0, 0.5, legs[i][0], legs[i][1], 12);
        sh.push(["c", legs[i][0], legs[i][1], 0.7, 0, 0.45, 0.9]);
      }
      sh.push(["c", 0, -hd, 5, 0, 0.14, 7], ["r", -W / 2, -1.5, W / 2, 1.5, 0.08, 10]);
    }
    // Tension fabric stands (and fabric backdrops): a pillowcase print pulled over an aluminium tube frame with rounded top
    // corners, standing in a steel base plate (backdrops: flat feet). The front (and back) prints cover the flat faces; the
    // rounded frame edges carry the outermost print colour (the wrap zone itself is never drawn).
    function buildPillow(G, sh, big) {
      var C = state, m = C.m, W = C.vis[2], H = C.vis[3], two = C.faces === 2, plate = !big && m.plateW > 0,
        r = big ? 0.8 : Math.max(0.3, (m.tubeDia || 1.25) / 2), Rc = Math.max(0.5, Math.min(W / 3, big ? 2.5 : m.topCornerRadius || 4.5)),
        pH = plate ? Math.max(0.1, m.plateH || 0.4) : 0.4, y0 = big ? 2.4 : pH + 0.8, n = 10, path = [], i, a;
      function pt(x, y, nx, ny) { path.push([x, y, nx, ny]); }
      function uvF(x, y) { return [(x + W / 2) / W, (y - y0) / H]; }
      pt(-W / 2, y0, -1, 0);
      for (i = 0; i <= n; i++) { a = PI - PI / 2 * i / n; pt(-W / 2 + Rc + Rc * Math.cos(a), y0 + H - Rc + Rc * Math.sin(a), Math.cos(a), Math.sin(a)); }
      for (i = 0; i <= n; i++) { a = PI / 2 - PI / 2 * i / n; pt(W / 2 - Rc + Rc * Math.cos(a), y0 + H - Rc + Rc * Math.sin(a), Math.cos(a), Math.sin(a)); }
      pt(W / 2, y0, 1, 0);
      var poly = path.map(function (q) { return [q[0], q[1]]; }), np = path.length;
      addTo(G, flatPoly(poly, r, 1, uvF), frontMat);
      addTo(G, flatPoly(poly, -r, -1, uvF), two ? backMat : M.fabric);
      function edge(back) {
        return surf(np - 1, 6, function (i, j, o) {
          var q = path[i], f = (back ? 1 + j / 6 : j / 6) * PI / 2, sn = Math.sin(f), cs = Math.cos(f), uv = uvF(q[0], q[1]);
          o[0] = q[0] + r * sn * q[2]; o[1] = q[1] + r * sn * q[3]; o[2] = r * cs;
          o[3] = sn * q[2]; o[4] = sn * q[3]; o[5] = cs; o[6] = back ? 1 - uv[0] : uv[0]; o[7] = uv[1];
        });
      }
      addTo(G, edge(false), frontMat);
      addTo(G, edge(true), two ? backMat : M.fabric);
      boxAt(G, M.cap, W, 0.12, 2 * r - 0.1, 0, y0 + 0.05, 0); // zipped bottom
      var xs = big && W > 70 ? [-W / 2, 0, W / 2] : [-W / 2, W / 2], fl = big ? 26 : 15, fw = big ? 3.4 : 2.6;
      for (i = 0; i < xs.length; i++) {
        cylAt(G, M.alu, r * 0.7, r * 0.7, pH, y0 + 0.3, xs[i], 0);
        if (!plate) { foot(G, M.alu, xs[i], 0, fw, fl, 0, pH); sh.push(["r", xs[i] - fw / 2, -fl / 2, xs[i] + fw / 2, fl / 2, 0.42, 0.9]); }
      }
      if (plate) { // one heavy steel plate under the frame
        var pw = Math.max(W + 2, m.plateW), pd = Math.max(4, m.plateD || 16);
        addTo(G, prism(rrect(0, 0, pw, pd, 1.2, 4), 0, pH, [0, 2, 1]), M.steel);
        sh.push(["r", -pw / 2, -pd / 2, pw / 2, pd / 2, 0.4, 1]);
      }
      sh.push(["r", -W / 2 - r, -r, W / 2 + r, r, 0.24, 3.5], ["r", -W / 2 - 4, -6, W / 2 + 4, 6, 0.13, 14]);
    }
    // Step and repeat: a backdrop with top and bottom pole pockets on an adjustable frame (two telescopic uprights on
    // flat feet, cross bars running inside the pockets)
    function buildPocket(G, sh) {
      var C = state, m = C.m, W = C.vis[2], H = C.vis[3], yb = Math.max(0.5, m.graphicBottomAboveFloor), yt = yb + H, ux = W / 2 + 1.6,
        bz = -0.85, fl = Math.max(6, m.footLen), fw = Math.max(1, m.footW), i, j, y, bars = [],
        pk = C.pk.length ? C.pk : [[C.vis[1], 3], [C.vis[1] + H - 3, 3]];
      addTo(G, sheet(W, H, 0, yb, 0, 1), frontMat);
      addTo(G, sheet(W, H, 0, yb, 0, -1), C.faces === 2 ? backMat : M.backing);
      for (i = 0; i < pk.length; i++) { // the pocket's fabric tube behind the band, a cross bar inside it
        y = yt - (pk[i][0] + pk[i][1] / 2 - C.vis[1]);
        if (y < yb - 0.5 || y > yt + 0.5) continue;
        bars.push(y);
        rod(G, M.backing, Math.min(0.85, pk[i][1] / 3.3), [-W / 2 + 0.05, y, bz], [W / 2 - 0.05, y, bz], 16);
        rod(G, M.alu, 0.5, [-ux, y, bz], [ux, y, bz], 12);
      }
      var top = Math.max(yt + m.uprightExtraTop, (bars.length ? Math.max.apply(null, bars) : 0) + 1), ym = top * 0.48;
      for (i = -1; i <= 1; i += 2) {
        cylAt(G, M.alu, 0.81, 0.81, 0.4, ym, i * ux, bz);
        cylAt(G, M.alu, 0.62, 0.62, ym, top, i * ux, bz);
        cylAt(G, M.cap, 0.98, 0.95, ym - 0.6, ym + 1, i * ux, bz);
        cylAt(G, M.cap, 0.75, 0.7, top, top + 0.8, i * ux, bz);
        for (j = 0; j < bars.length; j++) boxAt(G, M.cap, 1.9, 1.5, 1.9, i * ux, bars[j], bz);
        foot(G, M.alu, i * ux, bz, fw, fl, 0, 0.4);
        sh.push(["r", i * ux - fw / 2, bz - fl / 2, i * ux + fw / 2, bz + fl / 2, 0.42, 0.9]);
      }
      sh.push(["r", -W / 2, -1.6, W / 2, 0.2, 0.14, 4], ["r", -W / 2 - 6, -12, W / 2 + 6, 10, 0.1, 16]);
    }

    /* ---------- the floor: a soft disc with baked contact shadows, fading into the background ---------- */
    function paintShadows(g, X0, Z0, s, list) {
      var OFF = 4096, i, e;
      for (i = 0; i < list.length; i++) {
        e = list[i];
        g.save(); g.shadowColor = "rgba(24,24,20," + e[5] + ")"; g.shadowBlur = Math.max(1, e[6] * s); g.shadowOffsetX = OFF;
        g.fillStyle = "#000"; g.beginPath();
        if (e[0] === "c") g.arc((e[1] - X0) * s - OFF, (e[2] - Z0) * s, Math.max(0.5, e[3] * s), 0, PI * 2);
        else g.rect((e[1] - X0) * s - OFF, (e[2] - Z0) * s, (e[3] - e[1]) * s, (e[4] - e[2]) * s);
        g.fill(); g.restore();
      }
    }
    function paintGround(box, list) {
      var N = groundCv.width, g = groundCv.getContext("2d"), cx = (box.min.x + box.max.x) / 2, cz = (box.min.z + box.max.z) / 2,
        R = Math.max(box.max.x - box.min.x, box.max.z - box.min.z) * 0.62 + 30, s = N / (2 * R), rnd = rng(11), i;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.globalCompositeOperation = "source-over";
      g.shadowColor = "rgba(0,0,0,0)"; g.shadowBlur = 0;
      g.clearRect(0, 0, N, N);
      g.fillStyle = "#dad8d3"; g.fillRect(0, 0, N, N);
      for (i = 0; i < 7000; i++) {
        g.fillStyle = rnd() > 0.5 ? "rgba(255,255,255,0.35)" : "rgba(90,88,84,0.14)";
        g.fillRect(rnd() * N, rnd() * N, 1 + rnd() * 1.5, 1 + rnd() * 1.5);
      }
      paintShadows(g, cx - R, cz - R, s, list);
      var fade = g.createRadialGradient(N / 2, N / 2, 0, N / 2, N / 2, N / 2);
      fade.addColorStop(0, "rgba(0,0,0,1)"); fade.addColorStop(0.5, "rgba(0,0,0,1)"); fade.addColorStop(0.76, "rgba(0,0,0,0.5)");
      fade.addColorStop(0.96, "rgba(0,0,0,0)"); fade.addColorStop(1, "rgba(0,0,0,0)");
      g.globalCompositeOperation = "destination-in"; g.fillStyle = fade; g.fillRect(0, 0, N, N);
      g.globalCompositeOperation = "source-over";
      groundTex.needsUpdate = true;
      if (!ground) {
        ground = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), groundMat);
        ground.rotation.x = -PI / 2; ground.renderOrder = -1;
        scene.add(ground);
      }
      ground.scale.set(R, R, 1);
      ground.position.set(cx, 0.02, cz);
    }

    function buildAll() {
      if (standRoot) { scene.remove(standRoot); disposeGeos(); }
      standRoot = new THREE.Group();
      scene.add(standRoot);
      var sh = [], fl = sh, f = state.fam;
      if (f === "x-stand") buildX(standRoot, sh);
      else if (f === "tension") buildPillow(standRoot, sh, false);
      else if (f === "step-repeat") { if (state.style === "pocket") buildPocket(standRoot, sh); else buildPillow(standRoot, sh, true); }
      else {
        buildRetract(standRoot, sh);
        if (f === "tabletop") { fl = []; buildSlab(standRoot, sh, fl); }
      }
      standRoot.updateMatrixWorld(true);
      var box = new THREE.Box3().setFromObject(standRoot);
      paintGround(box, fl);
      var X0 = box.min.x, X1 = box.max.x, Z0 = box.min.z, Z1 = box.max.z, Y1 = box.max.y + 0.3,
        mg = Math.max(0.6, 0.03 * Math.max(Y1, X1 - X0)), i;
      X0 -= mg; X1 += mg; Z0 -= mg; Z1 += mg;
      ptsAll = []; ptsNear = [];
      cAll.set((X0 + X1) / 2, Y1 * 0.5, (Z0 + Z1) / 2);
      for (i = 0; i < 8; i++) {
        ptsAll.push(new THREE.Vector3(i & 1 ? X1 : X0, i & 2 ? Y1 : 0, i & 4 ? Z1 : Z0));
        ptsNear.push(new THREE.Vector3(cAll.x + (i & 1 ? 1 : -1) * (X1 - X0) * 0.17, cAll.y + (i & 2 ? 1 : -1) * Y1 * 0.17, cAll.z + (i & 4 ? 1 : -1) * (Z1 - Z0) * 0.17));
      }
      var big = Math.max(Y1, X1 - X0, Z1 - Z0);
      camera.near = Math.max(0.2, big / 300); camera.far = big * 30;
      camera.updateProjectionMatrix();
    }

    /* ---------- camera ---------- */
    var raf = 0, tween = null, backupT = 0;
    function now() { return win.performance && win.performance.now ? win.performance.now() : Date.now(); }
    function invalidate() {
      if (disposed) return;
      if (!raf) raf = win.requestAnimationFrame(frame);
      // a background tab does not run animation frames: draw anyway a little later
      if (!backupT) backupT = win.setTimeout(function () { backupT = 0; if (raf) { win.cancelAnimationFrame(raf); raf = 0; frame(); } }, 250);
    }
    function draw() { try { renderer.render(scene, camera); } catch (e) { } }
    function frame() {
      raf = 0;
      if (disposed || (!size.w && !measure())) return;
      var moving = !!tween;
      if (tween) stepTween();
      controls.update();
      holdInView();
      draw();
      if (tween || moving) invalidate();
    }
    function getSph() {
      var ox = camera.position.x - target.x, oy = camera.position.y - target.y, oz = camera.position.z - target.z,
        r = Math.sqrt(ox * ox + oy * oy + oz * oz) || 1;
      return { az: Math.atan2(ox, oz), el: Math.asin(Math.max(-1, Math.min(1, oy / r))), r: r };
    }
    function setSph(az, el, r) {
      var ce = Math.cos(el);
      camera.position.set(target.x + r * ce * Math.sin(az), target.y + r * Math.sin(el), target.z + r * ce * Math.cos(az));
      camera.lookAt(target);
    }
    function fitDistance(az, el, aspect, share, pts, c) {
      var tv = Math.tan(FOV * PI / 360), th = tv * (aspect || 1), ce = Math.cos(el), se = Math.sin(el), sa = Math.sin(az),
        ca = Math.cos(az), m = 1 / (share || 1), best = 1, i, x, y, z, cx, cy, cz, d;
      for (i = 0; i < pts.length; i++) {
        x = pts[i].x - c.x; y = pts[i].y - c.y; z = pts[i].z - c.z;
        cx = x * ca - z * sa; cy = -x * se * sa + y * ce - z * se * ca; cz = x * ce * sa + y * se + z * ce * ca;
        d = cz + Math.max(Math.abs(cx) * m / th, Math.abs(cy) * m / tv);
        if (d > best) best = d;
      }
      return best;
    }
    function aspectNow() { return size.w > 0 && size.h > 0 ? size.w / size.h : 1.3; }
    function farFor(az, el, asp) { return fitDistance(az, el, asp || aspectNow(), FILL_HOME, ptsAll, cAll); }
    function nearFor(az, el, asp) { return Math.min(farFor(az, el, asp) * 0.9, fitDistance(az, el, asp || aspectNow(), FILL_NEAR, ptsNear, cAll)); }
    function place(az, el, r) {
      target.copy(cAll); controls.target.copy(target);
      setSph(az, el, r);
    }
    function viewOf(name) {
      var v = typeof name === "string" && VIEWS.hasOwnProperty(name) ? VIEWS[name] : VIEWS.home;
      return { az: v[0], el: v[1] };
    }
    function updateLimits() {
      var s = getSph(), h = viewOf("home");
      fitHome = farFor(h.az, h.el);
      controls.minDistance = nearFor(s.az, s.el);
      controls.maxDistance = Math.max(fitDistance(0, 0.1, aspectNow(), FILL_FAR, ptsAll, cAll), fitHome * 1.3);
    }
    function clampR(r, az, el) { return Math.max(nearFor(az, el), Math.min(controls.maxDistance, r)); }
    function holdInView() {
      var s = getSph(), near = nearFor(s.az, s.el);
      controls.minDistance = near;
      if (!tween && s.r < near - 0.01) setSph(s.az, s.el, near);
    }
    function stepTween() {
      var t = (now() - tween.t0) / tween.ms;
      if (t >= 1) t = 1;
      var k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      place(tween.a.az + (tween.b.az - tween.a.az) * k, tween.a.el + (tween.b.el - tween.a.el) * k, tween.a.r + (tween.b.r - tween.a.r) * k);
      if (t >= 1) tween = null;
    }
    var reduced = false;
    try { reduced = !!(win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e5) { reduced = false; }
    function tweenTo(az, el, r, ms) {
      var a = getSph(), d = az - a.az;
      while (d > PI) d -= PI * 2;
      while (d < -PI) d += PI * 2;
      tween = { a: a, b: { az: a.az + d, el: el, r: r }, t0: now(), ms: reduced ? 1 : ms };
      invalidate();
    }
    function measure() {
      var w = host.clientWidth | 0, h = host.clientHeight | 0;
      if (w < 2 || h < 2) return false;
      var pr = Math.min(2, Math.max(1, win.devicePixelRatio || 1));
      if (w === size.w && h === size.h && pr === renderer.getPixelRatio()) return false;
      var oldFit = fitHome, had = size.w > 0;
      size.w = w; size.h = h;
      renderer.setPixelRatio(pr); renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      updateLimits();
      var s = getSph();
      if (had && !tween) place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
      else if (had && tween) tween.b.r = tween.b.r * fitHome / oldFit;
      else { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
      controls.update();
      return true;
    }
    function onControlsChange() { invalidate(); }
    function onControlsStart() { tween = null; canvas.style.cursor = "grabbing"; }
    function onControlsEnd() { canvas.style.cursor = "grab"; }
    controls.addEventListener("change", onControlsChange);
    controls.addEventListener("start", onControlsStart);
    controls.addEventListener("end", onControlsEnd);

    var FIELDS = ["key", "family", "name", "tpl", "visible", "hidden", "faces", "sides", "hardware", "grommets", "backTpl", "backVisible", "backHidden", "pockets", "model", "order"];
    var api = {
      set: function (o) {
        if (disposed || !o || typeof o !== "object") return;
        var k, oldFit = fitHome, s = getSph(), first = !builtKey,
          newKey = o.key !== undefined && keyOf(o.key) !== keyOf(input.key);
        if (newKey || (o.family !== undefined && str(o.family) !== str(input.family))) // a new stand: forget the old one's geometry
          for (k = newKey ? 1 : 2; k < FIELDS.length - 1; k++) if (o[FIELDS[k]] === undefined) delete input[FIELDS[k]];
        for (k = 0; k < FIELDS.length; k++) if (o[FIELDS[k]] !== undefined) input[FIELDS[k]] = o[FIELDS[k]];
        state = normalize(input);
        var gk = geoKey(state);
        if (gk !== builtKey) {
          buildAll(); builtKey = gk;
          updateLimits();
          if (first) { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
          else {
            if (tween) tween.b.r = tween.b.r * fitHome / oldFit;
            place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
          }
          controls.update();
        }
        crop("front"); crop("back"); bindTextures();
        invalidate();
      },
      setFace: function (face, cv) {
        if (disposed || (face !== "front" && face !== "back")) return;
        faces[face].src = cv && cv.width > 0 && cv.height > 0 ? cv : null;
        crop(face, true); bindTextures(); invalidate();
      },
      setTexture: function (cv) { api.setFace("front", cv); },
      refresh: function () { // after redrawing a canvas already passed (a new size is fine too)
        if (disposed) return;
        crop("front", true); crop("back", true); bindTextures();
        invalidate();
      },
      view: function (name) {
        if (disposed) return;
        var v = viewOf(name);
        tweenTo(v.az, v.el, farFor(v.az, v.el), 560);
      },
      zoom: function (dir) {
        if (disposed) return;
        var s = tween ? tween.b : getSph(), r = clampR(s.r * Math.pow(0.8, dir > 0 ? 1 : -1), s.az, s.el);
        tweenTo(s.az, s.el, r, 240);
      },
      resize: function () {
        if (disposed) return;
        if (measure()) { if (raf) { win.cancelAnimationFrame(raf); raf = 0; } draw(); invalidate(); }
      },
      snapshot: function (w, h, viewName) {
        if (disposed) return null;
        var out = null, oldPR = renderer.getPixelRatio(), oldSize = renderer.getSize(new THREE.Vector2()), oldAspect = camera.aspect,
          oldPos = camera.position.clone(), oldTarget = target.clone(), s = getSph();
        try {
          var cap = Math.min(4096, renderer.capabilities.maxTextureSize || 4096);
          w = Math.max(16, Math.min(cap, Math.round(w || size.w || 800)));
          h = Math.max(16, Math.min(cap, Math.round(h || size.h || 600)));
          renderer.setPixelRatio(1); renderer.setSize(w, h, false);
          camera.aspect = w / h; camera.updateProjectionMatrix();
          if (typeof viewName === "string" && VIEWS.hasOwnProperty(viewName)) {
            var v = viewOf(viewName);
            place(v.az, v.el, farFor(v.az, v.el, w / h));
          } else {
            place(s.az, s.el, s.r * farFor(s.az, s.el, w / h) / farFor(s.az, s.el, oldAspect || 1));
          }
          renderer.render(scene, camera);
          out = doc.createElement("canvas"); out.width = w; out.height = h;
          var ctx = out.getContext("2d");
          ctx.fillStyle = bg; ctx.fillRect(0, 0, w, h); ctx.drawImage(canvas, 0, 0, w, h);
        } catch (e) { out = null; }
        try {
          renderer.setPixelRatio(oldPR); renderer.setSize(oldSize.x, oldSize.y, false);
          camera.aspect = oldAspect; camera.updateProjectionMatrix();
          target.copy(oldTarget); controls.target.copy(target); camera.position.copy(oldPos); camera.lookAt(target);
          renderer.render(scene, camera);
        } catch (e2) { }
        return out;
      },
      // extra (not in the contract): small debug numbers for testing
      stats: function () {
        if (disposed) return null;
        var m = renderer.info.memory, r = renderer.info.render;
        return { geometries: m.geometries, textures: m.textures, frame: r.frame, calls: r.calls, triangles: r.triangles,
          family: state.fam, key: state.key, faces: state.faces, visible: state.vis.slice(), order: state.order,
          style: state.fam === "step-repeat" ? state.style : null };
      },
      dispose: function () {
        if (disposed) return;
        disposed = true;
        if (raf) win.cancelAnimationFrame(raf);
        if (backupT) win.clearTimeout(backupT);
        raf = 0; backupT = 0; tween = null;
        try { if (ro) ro.disconnect(); } catch (e) { }
        win.removeEventListener("resize", onWinResize);
        doc.removeEventListener("visibilitychange", onVis);
        canvas.removeEventListener("webglcontextlost", onLost, false);
        canvas.removeEventListener("webglcontextrestored", onRestored, false);
        controls.removeEventListener("change", onControlsChange);
        controls.removeEventListener("start", onControlsStart);
        controls.removeEventListener("end", onControlsEnd);
        controls.dispose();
        disposeGeos();
        if (ground) ground.geometry.dispose();
        var list = [frontMat, backMat, groundMat, groundTex, slabMat, slabTex, placeTex, faces.front.tex, faces.back.tex], k;
        for (k in M) if (M.hasOwnProperty(k)) list.push(M[k]);
        for (k = 0; k < list.length; k++) try { if (list[k]) list[k].dispose(); } catch (e3) { }
        faces.front.tex = faces.back.tex = faces.front.src = faces.back.src = null;
        faces.front.cv.width = faces.back.cv.width = 1;
        try { renderer.dispose(); renderer.forceContextLoss(); } catch (e4) { }
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    };
    function onWinResize() { api.resize(); }
    function onLost(e) { e.preventDefault(); }
    function onRestored() { invalidate(); }
    function onVis() { if (!doc.hidden) invalidate(); }
    canvas.addEventListener("webglcontextlost", onLost, false);
    canvas.addEventListener("webglcontextrestored", onRestored, false);
    doc.addEventListener("visibilitychange", onVis);
    var ro = null;
    if (win.ResizeObserver) { ro = new win.ResizeObserver(function () { api.resize(); }); ro.observe(host); }
    win.addEventListener("resize", onWinResize);

    api.set({ key: "RS-33x81", family: "retractable" });
    if (!measure()) controls.update();
    invalidate();
    canvas.setAttribute("data-ardor-stand3d", "ready");
    return api;
  }

  root.ArdorStand3D = { create: create, version: "1.0.0" };
})(typeof window !== "undefined" ? window : this);
